fx.ns("shared.renderers", class LayoutRenderer extends fx.Component{
    
	constructor(data)
	{
		super(data);
	}

	contextMenu(e)
	{
        let items = [  {label : fx.text("Appliquer"), code : "apply"}];

        if (fx.get("app") != "frame")
            items.push( {label : fx.text("Appliquer à toutes les pages"), code : "applyall"} );

        if (this.data.accountid)
        {
            items.push({});
            items.push({label : fx.text("Supprimer"), code : "delete"});
        }
       
		return items;
	}

	onContextMenu(e)
	{
		switch(e.detail.code)
		{
			case "apply":
					this.data.event("apply-layout", {content : this.data.id});
				break;

			case "applyall":
					this.data.event("apply-layout-all", {content : this.data.id});
				break;

			case "delete" :
					this.data.delete();
				break;
		}
	}

	render()
	{
        return '<img class="draggable" data-behaviour="apply-layout" data-class="Layout" src="' + this.data.thumb + '" data-id="' + this.data.id + '" >';
	}

/*	create()
	{
		this.image = new fx.components.Image({className : "draggable", data : this.data.thumb});
		this.image.attr("data-class", "Layout");
		this.image.attr("data-behaviour", "apply-layout");
		this.image.attr("data-id", this.data.id );
		this.addChild(this.image);

		if (this.data.accountid)
		{
			this.deleteIcon = new fx.components.Image({data : fx.assets.deleteIcon, className : "delete", tooltip : fx.text("Supprimer")});
			this.deleteIcon.visibleAtStart = false;
			this.addChild(this.deleteIcon, {bottom:0, right:0, width:30, height:30});
		}
	}

	onReady()
	{
		super.onReady();

		this.on("mouseover", this.onMouseOver);
		this.on("mouseout", this.onMouseOut);

		if (this.deleteIcon)
			this.on("click", this.onRemove, this.deleteIcon);
	}


	onMouseOver()
	{
		this.deleteIcon.show();
	}

	onMouseOut()
	{
		this.deleteIcon.hide();
	}

	onRemove(e)
	{
		e.preventDefault();
		if (typeof e.stopPropagation == "function")
			e.stopPropagation();

		this.data.delete();
	}
*/
	
});